import AppState from "./../../common/appState";
import Cookie from "./../../common/components/cookieComponent";
import ErrorPopup from "./../../common/components/errorPopup";
import Loader from "./../../common/components/loader";
import Paywall from "./../../common/components/paywall";
import RegionManager from "./../../common/components/regionmanager";
import options from "./../../common/config";
import language from "./../../common/dictionary";
import HorsseriesStore from "./../../common/stores/horsseriesStore";
import AuthenticatorAuthorisationController from "./../../common/subscriptionmanagement/authenticatorAuthorisationController";
import APIManager from "./../../common/utilities/apimanager";
import CookieManager from "./../../common/utilities/cookiemanager";
import handleCrossOriginMessage from "./../../common/utilities/iframeUtils";
import SessionManager from "./../../common/utilities/sessionmanager";

const AnalyticsManager =
  require(`./../../../clients/${process.env.CLIENT}/js/analyticsManager`).default;
const config =
  require(`./../../../clients/${process.env.CLIENT}/js/analyticsConfig`).default;

export default class App {
  options = null;
  _appState = null;
  DOMContainer = null;

  sessionManager = null;
  regionManager = null;
  authenticatorAuthorisationController = null;

  constructor() {
    this.options = options.app;
    this.DOMContainer = document.querySelector("#main-app");
    if (window.location.search.indexOf("showpaywall") !== -1) {
      this.options.sidemenu.settings.paywallRedirectionUrl = null;
      this.options.settings.paywallRedirectionUrl = null;
      this.options.downloadComponent.paywallRedirectionUrl = null;
    }
  }

  initAppState() {
    const analyticsManager = new AnalyticsManager(
      config,
      this.options.showBackButtonParam
    );
    this._appState = new AppState(analyticsManager, this.options);
  }

  init() {
    if (this.options.useCookiePostfix) {
      CookieManager.setPostFix(process.env.CLIENT.toUpperCase());
    }
    this.initAppState();
    // only for debugging, make the app a global variable
    if (process.env.NODE_ENV !== "production") {
      window.appState = this._appState;
    }
    CookieManager.refreshCookies();
    this.sessionManager = new SessionManager(
      APIManager,
      CookieManager,
      this.options
    );
    this.sessionManager
      .getSessionInfo()
      .then(() => {
        this._appState.uuid = this.sessionManager.UUID;
        this._appState.userId = this.sessionManager.userId;
        this._appState.sessionId =
          this.sessionManager.session.SessionInfo.SessionId;
        this._appState.timeBasedUnlimitedAccessEnabled = this.sessionManager
          .session.AppConfigData.TimeBasedUnlimitedAccessEnabled
          ? this.sessionManager.session.AppConfigData
              .TimeBasedUnlimitedAccessEnabled
          : false;
        this.regionManager = new RegionManager(
          this._appState,
          APIManager,
          CookieManager,
          this.options.regionmanager
        );
        if (this.options.isReader) {
          this._appState.triggerEvent(
            "RegionSet",
            this.regionManager.getCurrentRegion()
          );
        }
        //set number of articles that can be shared
        this._appState.socialSharingNumberOfArticles =
          this.sessionManager.session.AppConfigData.SharingFreemiumLimit;
        this._appState.socialSharingReset =
          this.sessionManager.session.AppConfigData.SocialSharingReset;
        this.authenticatorAuthorisationController =
          new AuthenticatorAuthorisationController(
            this._appState,
            this.sessionManager,
            CookieManager,
            this.options.authenticatorauthorisationcontroller
          );
        this.initRender();
      })
      .catch(() => {
        //TODO: show error dialog
      });
    window.addEventListener(
      "message",
      (e) => {
        handleCrossOriginMessage(e);
      },
      false
    );
  }

  render(dustfile) {
    if (this.DOMContainer !== null) {
      Dust.render(dustfile, this.createContext(), (err, result) => {
        this.DOMContainer.innerHTML = result;
        this._appState.initResizer();
        this.renderingDone();
      });
    }
  }

  renderingDone() {
    this.loader = new Loader();
    if (this.options.cookie.cookieEnabled) {
      new Cookie(
        this._appState,
        this.DOMContainer.querySelector("#cookie"),
        CookieManager,
        this.options.cookie
      );
    }
    this.paywall = new Paywall(
      this._appState,
      this.authenticatorAuthorisationController,
      this.DOMContainer.querySelector("#paywall"),
      this.options.paywallcomponent
    );
    this.errorPopup = new ErrorPopup(
      this._appState,
      this.DOMContainer.querySelector("#error")
    );
    this.initAfterRendering();
    this.attachListeners();
    this.startApp();
  }

  initHorsseriesStore(additionalDownloadTokens) {
    this.horsSeriesStore = new HorsseriesStore(
      APIManager,
      additionalDownloadTokens,
      this.options.sizes.covers,
      this.options.horsserie,
      language.moment,
      this.options.dateFormat
    );
    this.horsSeriesStore.on("horsseries:loaded", () => {
      this.onHorsseriesLoaded();
    });
    this.horsSeriesStore.loadHorsseries();
  }

  // methods to overwrite:

  initRender() {}

  createContext() {
    return {};
  }

  initAfterRendering() {}

  attachListeners() {}

  onHorsseriesLoaded() {}
}



// WEBPACK FOOTER //
// ./src/web/shared/app.js